/*
 Created by CHT 2020/1/31 15:26
*/
import RyQuillEditor from './RyQuillEditor'
import ContactBox from "./ContactBox";
import RyContact from "./RyContact/index"
import Sectional from "../RyForm/redact/FillSectional";
import NodeListPopup from "./mix_form/NodeListPopup";
import MemberFieldSelectContacts from "./RyContact/MemberFieldSelectContacts";
import AtomListPreview from "./AtomImagePreview/AtomListPreview";
import VueQr from 'vue-qr'
import Empty from './empty.vue'

export default {
  install (Vue) {
    Vue.component('ry-quill-editor', RyQuillEditor)
    Vue.component('ContactBox', ContactBox)
    Vue.component('RyContact', RyContact)
    Vue.component('Sectional', Sectional)
    Vue.component('NodeListPopup', NodeListPopup)
    Vue.component('MemberFieldSelectContacts', MemberFieldSelectContacts)
    Vue.component('VueQr', VueQr)
    Vue.component('AtomListPreview', AtomListPreview)
    Vue.component('Empty',Empty)
  }
}
